/**
 * Reads the payload of a JWT without verifying it — the token comes from our
 * own backend and is only used to pull out the session id.
 *
 * Deliberately dependency-free — decoding one claim does not warrant a
 * dependency.
 */
export function decodeJwtPayload<T>(token: string): T {
  const payload = token.split('.')[1];

  if (!payload) {
    throw new Error('Malformed JWT: missing payload segment');
  }

  const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
  const json = decodeURIComponent(
    atob(base64)
      .split('')
      .map((char) => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(''),
  );

  return JSON.parse(json) as T;
}
